import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import {
  Select2Data,
  Select2DataCustomerId,
  Select3Data,
  Select4Data,
} from "../../../utils/common";

export const AllPermmission = createAsyncThunk(
  "common/masters/all-permission",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPermmission}?term=${filter?.name ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}`,
      );
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCustomerType = createAsyncThunk(
  "common/masters/all-customer-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCustomerType}?name=${filter}`);

      return await Select2Data(res.data, "customer_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPrefferedCommunicationMode = createAsyncThunk(
  "common/masters/all-preffered-communication",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPrefferedCommunicationMode);

      return await Select2Data(res.data, "preferred_communication_mode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCustomer = createAsyncThunk(
  "common/masters/all-customer",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCustomer);

      return await Select2Data(res.data, "client_name_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCustomerId = createAsyncThunk(
  "common/masters/all-customer-id",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCustomer);

      return await Select2DataCustomerId(res.data, "client_name_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllChemist = createAsyncThunk(
  "common/masters/all-chemist",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllChemist);

      return await Select2Data(res.data, "chemist_assigned_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCalibratedBy = createAsyncThunk(
  "common/masters/all-calibrated-by",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCalibratedBy);

      return await Select2Data(res.data, "calibrated_by_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllSampReceiver = createAsyncThunk(
  "common/masters/all-sample-receiver",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllSampReceiver);

      return await Select2Data(res.data, "samp_received_by_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllParameter = createAsyncThunk(
  "common/masters/all-parameter",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllParameter);

      return await Select2Data(res.data, "parameter_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCategory = createAsyncThunk(
  "common/masters/all-category",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCategory);

      return await Select2Data(res.data, "category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const AllMethodOfTesting = createAsyncThunk(
  "common/masters/all-method-of-testing",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllMethodOfTesting);

      return await Select2Data(res.data, "method_of_testing_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const AllMaterialTested = createAsyncThunk(
  "common/masters/all-material-tested",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllMaterialTested);

      return await Select2Data(res.data, "material_tested_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const AllComponent = createAsyncThunk(
  "common/masters/all-component",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllComponent);

      return await Select2Data(res.data, "component_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const AllTestMethod = createAsyncThunk(
  "common/masters/all-test-method",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTestMethod);

      return await Select2Data(res.data, "test_method_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const AllPriority = createAsyncThunk(
  "common/masters/all-priority",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPriority);

      return await Select2Data(res.data, "priority_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllSampStatus = createAsyncThunk(
  "common/masters/all-samp-status",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllSampStatus);

      return await Select2Data(res.data, "sample_management_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const AllCalibrationStatus = createAsyncThunk(
  "common/masters/all-calibration-status",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCalibrationStatus);

      return await Select2Data(res.data, "calibration_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      return await Select2Data(res.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllStateWId = createAsyncThunk(
  "common/masters/all-state",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllState}?name=${filter}`);

      return await Select2Data(res.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCity = createAsyncThunk(
  "common/masters/all-city/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}/${stateId}?name=${name}`);

      console.log(res, "ooooooooooo");

      return await Select2Data(res.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllGender = createAsyncThunk(
  "common/masters/all-gender",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllGender}`);

      return await Select2Data(res.data, "gender_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ countryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllState}/${countryId}?name=${name}`,
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// City - Get All (for a specific state)

// Pincode - Get All (for a specific city)
export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${cityId}?name=${name}`,
      );
      return await Select2Data(res.data.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllArea = createAsyncThunk(
  "common/masters/all-area/:id",
  async ({ pincodeId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllArea}/${pincodeId}?name=${name}`,
      );
      return await Select2Data(res.data.data, "area_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllRoles = createAsyncThunk(
  "common/masters/all-role",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllRoles}?name=${filter}`);

      return await Select2Data(res.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllUser = createAsyncThunk(
  "common/masters/all-user",
  async ({ role_id }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTeam}/${role_id}`);
      return await Select2Data(res.data, "designer_id");
      // return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allDesignation = createAsyncThunk(
  "common/masters/all-designation",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allDesignation);

      return await Select2Data(res.data, "material_tested_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allQualification = createAsyncThunk(
  "common/masters/all-qualification",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allQualification);

      return await Select2Data(res.data, "qualification_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allSpecialization = createAsyncThunk(
  "common/masters/all-specification",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allSpecialization);

      return await Select2Data(res.data, "specialization_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allRelevant_Training = createAsyncThunk(
  "common/masters/all-relevant-training",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allRelevant_Training);

      return await Select2Data(res.data, "relevant_training_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPaymentMethod = createAsyncThunk(
  "common/masters/all-payment-method",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPaymentMethod);

      return await Select2Data(res.data, "payment_method_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allInstrumentManagement = createAsyncThunk(
  "common/masters/all-instrument-management",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allInstrumentManagement);
      return Select3Data(res.data, "instrument_name");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allRoomType = createAsyncThunk(
  "common/masters/all-room-type",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allRoomType);

      return await Select2Data(res.data, "room_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allPerformance = createAsyncThunk(
  "common/masters/all-performance",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allPerformance);

      return await Select2Data(res.data, "performance_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allServiceUsed = createAsyncThunk(
  "common/masters/all-servicd-used",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allServiceUsed);

      return await Select2Data(res.data, "service_used_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allNatureComplaints = createAsyncThunk(
  "common/masters/all-nature-of-complaints",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allNatureComplaints);

      return await Select2Data(res.data, "nature_of_complaint_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allSampleManagement = createAsyncThunk(
  "common/masters/all-sample-management",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allSampleManagement);

      return await Select4Data(res.data, "unique_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allCustomerDetail = createAsyncThunk(
  "common/masters/all-customer-details",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.allCustomerDetail}?name=${filter}`);
      return res.data;
      // return await Select2Data(res.data, "volunteer_detail_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allSelectionType = createAsyncThunk(
  "common/masters/all-selection-type",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allSelectionType);

      return await Select2Data(res.data, "selection_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allTestType = createAsyncThunk(
  "common/masters/all-test-type",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allTestType);

      return await Select2Data(res.data, "test_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allVerificationType = createAsyncThunk(
  "common/masters/all-verification-type",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allVerificationType);

      return await Select2Data(res.data, "type_of_verification_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allValidityType = createAsyncThunk(
  "common/masters/all-validity-type",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allValidityType);

      return await Select2Data(res.data, "validity_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allTestedBy = createAsyncThunk(
  "common/masters/all-tested-by",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allTestedBy);

      return await Select2Data(res.data, "tested_by_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allComplaintStatus = createAsyncThunk(
  "common/masters/all-complaint-status",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allComplaintStatus);

      return await Select2Data(res.data, "complaint_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allDepartment = createAsyncThunk(
  "common/masters/all-department",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allDepartment);

      return await Select2Data(res.data, "department_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allNon_Confirming_Work_Status = createAsyncThunk(
  "common/masters/all-non-confirming-work-status",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allNon_Confirming_Work_Status);

      return await Select2Data(res.data, "non_confirming_work_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allManagement_System_Requirement_Status = createAsyncThunk(
  "common/masters/all-management-system-requirement-status",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        APIS.Commons.allManagement_System_Requirement_Status,
      );

      return await Select2Data(
        res.data,
        "management_system_requirement_status_id",
      );
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPaymentStatus = createAsyncThunk(
  "common/masters/all-payment-status",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPaymentStatus);

      return await Select2Data(res.data, "payment_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allExternal_Audit_Status = createAsyncThunk(
  "common/masters/all-external",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allExternal_Audit_Status);

      return await Select2Data(res.data, "external_audit_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allUsers = createAsyncThunk(
  "common/masters/all-users",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allUsers);

      return await Select2Data(res.data, "user_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllInstrumentMaintance = createAsyncThunk(
  "common/masters/all-instrument-maintence",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllInstrumentMaintance);

      return await Select2Data(res.data, "maintenance_check_point_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTrainingField = createAsyncThunk(
  "common/masters/all-field",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTrainingField);

      return await Select2Data(res.data, "training_field_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTrainingStatus = createAsyncThunk(
  "common/masters/all-status",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTrainingStatus);

      return await Select2Data(res.data, "training_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTrainingType = createAsyncThunk(
  "common/masters/all-type",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTrainingType);

      return await Select2Data(res.data, "training_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPermissionDropdown = createAsyncThunk(
  "common/masters/all-permission-dropdown",
  async ({ permission_id = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.allPermissionDropdown}?permission_id=${permission_id}`,
      );

      return await Select2Data(res.data, "permission_dropdown_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCustomerStatus = createAsyncThunk(
  "common/masters/all-customer-status",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCustomerStatus);

      return await Select2Data(res.data, "customer_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const Slice = createSlice({
  name: "common",
  initialState: {
    payment_history: [],
    all_owner: [],
    all_property_type: [],
    all_property_status: [],
    all_property: [],
    all_sub_history: [],
    all_room: [],
    all_country: [],
    all_state: [],
    all_city: [],
    all_pincode: [],
    all_area: [],
    all_roomType: [],
    all_category: [],
    single_category: {},
    all_subcategory: [],
    all_childcategory: [],
    all_partners: [],
    all_whychooseus: [],
    all_industry: [],
    all_companysize: [],
    all_needs: [],
    all_faqs: [],
    all_subfaq: [],
    all_meterial: [],
    all_quantity: [],
    all_lamination: [],
    all_print_location: [],
    all_envelope: [],
    all_orientation: [],
    all_shapes: [],
    all_socialmedia: [],
    all_blogcategory: [],
    all_blogs: [],
    all_size: [],
    all_download_type: [],
    all_orderstatus: [],
    all_permission: [],
    all_roles: [],

    all_team: [],
    all_product: [],
    all_gender: [],
    all_customer_type: [],
    all_preffered_communication_mode: [],
    all_state_w_id: [],

    all_customer: [],
    all_category: [],
    all_method_of_testing: [],
    all_priority: [],

    all_samp_status: [],

    all_calibrated_by: [],
    all_calibration_status: [],
    all_chemist: [],
    all_samp_reciver: [],
    all_parameter: [],
    all_material_tested: [],
    all_component: [],
    all_test_method: [],

    all_designation: [],
    all_qualification: [],
    all_specialization: [],
    all_relevant_training: [],
    all_payment_method: [],
    all_instrument_management: [],
    all_room_type: [],
    all_performance: [],
    all_service_used: [],
    all_nature_complaints: [],
    all_sample_management: [],
    all_customer_details: [],
    all_selection_type: [],
    all_test_type: [],
    all_verification_type: [],
    all_validity_type: [],
    all_teseted_by: [],

    all_payment_status: [],
    all_complaint_status: [],
    all_department: [],
    all_non_confirmin_work_status: [],
    all_management_system_required_status: [],
    all_external_audit_status: [],
    all_instrument_maintence: [],
    all_users: [],
    all_training_status: [],
    all_training_field: [],
    all_training_type: [],
    all_customer_status: [],
    all_permission_dropdown: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllCustomerType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCustomerType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_customer_type = action.payload || [];
      })
      .addCase(AllCustomerType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPrefferedCommunicationMode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPrefferedCommunicationMode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_preffered_communication_mode = action.payload || [];
      })
      .addCase(AllPrefferedCommunicationMode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCustomer.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCustomer.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_customer = action.payload || [];
      })
      .addCase(AllCustomer.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCustomerId.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCustomerId.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_customer = action.payload || [];
      })
      .addCase(AllCustomerId.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllChemist.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllChemist.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_chemist = action.payload || [];
      })
      .addCase(AllChemist.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllCalibratedBy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCalibratedBy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_calibrated_by = action.payload || [];
      })
      .addCase(AllCalibratedBy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSampReceiver.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSampReceiver.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_samp_reciver = action.payload || [];
      })
      .addCase(AllSampReceiver.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllParameter.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllParameter.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_parameter = action.payload || [];
      })
      .addCase(AllParameter.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_category = action.payload || [];
      })
      .addCase(AllCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllMethodOfTesting.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllMethodOfTesting.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_method_of_testing = action.payload || [];
      })
      .addCase(AllMethodOfTesting.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllMaterialTested.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllMaterialTested.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_material_tested = action.payload || [];
      })
      .addCase(AllMaterialTested.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllComponent.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllComponent.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_component = action.payload || [];
      })
      .addCase(AllComponent.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllTestMethod.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTestMethod.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_test_method = action.payload || [];
      })
      .addCase(AllTestMethod.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllPriority.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPriority.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_priority = action.payload || [];
      })
      .addCase(AllPriority.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSampStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSampStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_samp_status = action.payload || [];
      })
      .addCase(AllSampStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllCalibrationStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCalibrationStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_calibration_status = action.payload || [];
      })
      .addCase(AllCalibrationStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllGender.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllGender.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_gender = action.payload || [];
      })
      .addCase(AllGender.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllStateWId.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllStateWId.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state_w_id = action.payload || [];
      })
      .addCase(AllStateWId.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllArea.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllArea.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_area = action.payload || [];
      })
      .addCase(AllArea.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPermmission.pending, (state) => {
        console.log("action.payload pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPermmission.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_permission = action.payload || {};
      })
      .addCase(AllPermmission.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      })

      .addCase(AllRoles.pending, (state) => {
        console.log("action.payload pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllRoles.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_roles = action.payload || [];
      })
      .addCase(AllRoles.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      })

      .addCase(AllUser.pending, (state) => {
        console.log("action.payload pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllUser.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action.payload, "action.payload");

        state.all_team = action.payload || [];
        console.log(action.payload, "action.payload");
      })
      .addCase(AllUser.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        console.log("action.payload reject");
        state.error = action.payload;
      })

      .addCase(allDesignation.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allDesignation.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_designation = action.payload || [];
      })
      .addCase(allDesignation.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allQualification.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allQualification.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_qualification = action.payload || [];
      })
      .addCase(allQualification.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allSpecialization.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allSpecialization.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_specialization = action.payload || [];
      })
      .addCase(allSpecialization.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(allRelevant_Training.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allRelevant_Training.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_relevant_training = action.payload || [];
      })
      .addCase(allRelevant_Training.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPaymentMethod.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPaymentMethod.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_payment_method = action.payload || [];
      })
      .addCase(AllPaymentMethod.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allInstrumentManagement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allInstrumentManagement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_instrument_management = action.payload || [];
      })
      .addCase(allInstrumentManagement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allRoomType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allRoomType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_room_type = action.payload || [];
      })
      .addCase(allRoomType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allPerformance.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allPerformance.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_performance = action.payload || [];
      })
      .addCase(allPerformance.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allServiceUsed.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allServiceUsed.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_service_used = action.payload || [];
      })
      .addCase(allServiceUsed.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allNatureComplaints.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allNatureComplaints.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_nature_complaints = action.payload || [];
      })
      .addCase(allNatureComplaints.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allSampleManagement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allSampleManagement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_sample_management = action.payload || [];
      })
      .addCase(allSampleManagement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allCustomerDetail.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allCustomerDetail.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_customer_details = action.payload || [];
      })
      .addCase(allCustomerDetail.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allSelectionType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allSelectionType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_selection_type = action.payload || [];
      })
      .addCase(allSelectionType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allTestType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allTestType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_test_type = action.payload || [];
      })
      .addCase(allTestType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allVerificationType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allVerificationType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_verification_type = action.payload || [];
      })
      .addCase(allVerificationType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(allValidityType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allValidityType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_validity_type = action.payload || [];
      })
      .addCase(allValidityType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allTestedBy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allTestedBy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_teseted_by = action.payload || [];
      })
      .addCase(allTestedBy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPaymentStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPaymentStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_payment_status = action.payload || [];
      })
      .addCase(AllPaymentStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(allComplaintStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allComplaintStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_complaint_status = action.payload || [];
      })
      .addCase(allComplaintStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allDepartment.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allDepartment.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_department = action.payload || [];
      })
      .addCase(allDepartment.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allNon_Confirming_Work_Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allNon_Confirming_Work_Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_non_confirmin_work_status = action.payload || [];
      })
      .addCase(allNon_Confirming_Work_Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allManagement_System_Requirement_Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(
        allManagement_System_Requirement_Status.fulfilled,
        (state, action) => {
          state.status = IDS.SLICESTATUS.Succeeded;
          state.all_management_system_required_status = action.payload || [];
        },
      )
      .addCase(
        allManagement_System_Requirement_Status.rejected,
        (state, action) => {
          state.status = IDS.SLICESTATUS.Failed;
          state.error = action.payload;
        },
      )

      .addCase(allExternal_Audit_Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allExternal_Audit_Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_external_audit_status = action.payload || [];
      })
      .addCase(allExternal_Audit_Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allUsers.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allUsers.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_users = action.payload || [];
      })
      .addCase(allUsers.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllInstrumentMaintance.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllInstrumentMaintance.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_instrument_maintence = action.payload || [];
      })
      .addCase(AllInstrumentMaintance.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTrainingField.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTrainingField.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_training_field = action.payload || [];
      })
      .addCase(AllTrainingField.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTrainingStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTrainingStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_training_status = action.payload || [];
      })
      .addCase(AllTrainingStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTrainingType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTrainingType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_training_type = action.payload || [];
      })
      .addCase(AllTrainingType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPermissionDropdown.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPermissionDropdown.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_permission_dropdown = action.payload || [];
      })
      .addCase(AllPermissionDropdown.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCustomerStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCustomerStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_customer_status = action.payload || [];
      })
      .addCase(AllCustomerStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
